module.exports = __webpack_public_path__ + "media/landing-desktop/assets/images/image-placeholder-94ec20900e7e6e550290a43e41538994.svg";